import React, { useCallback, useState } from 'react';
import { FormikHelpers } from 'formik';
import classNames from 'classnames';
import {
  Wrapper,
  BackgroundImage,
  Grid,
  Content,
  StyledSingleInputForm
} from './styles';
import { CustomVisibilitySensor, Title } from 'components';

function Futuro() {
  return (
    <CustomVisibilitySensor offset={{ bottom: -300, top: -300 }}>
      {({ isVisible }) => (
        <Wrapper>
          <BackgroundImage
            alt=""
            className={classNames({ isVisible })}
            src={require('assets/futuro-bg.jpg')}
          />
          <Grid className="grid">
            <Content>
              <Title>O futuro da dispensa de medicamentos, hoje.</Title>
              <StyledSingleInputForm
                buttonText="Quero me cadastrar"
                type="farmacias"
              />
            </Content>
          </Grid>
        </Wrapper>
      )}
    </CustomVisibilitySensor>
  );
}

export default Futuro;
